// extracted by mini-css-extract-plugin
export default {"containerSearch":"searchFincas_containerSearch__+xzhJ","containerInput":"searchFincas_containerInput__ET9pe"};